export default {
    clipDuration: '{seconds}s clip',
    guideLabel: 'Platform guide',
    guideTitle: 'Platform length guide',
    guideDescription: 'Compare this clip length with published video limits.',
    durationOnly: 'Length only. Check the final video format too.',
    youtubeShorts: 'YouTube Shorts',
    youtubeLimit: 'Up to 3 min',
    youtubeNote: 'Square or vertical video required for Shorts.',
    linkedInFeed: 'LinkedIn feed video',
    linkedInLimit: '3 sec to 15 min on desktop',
    linkedInNote: 'Mobile uploads may start at 2 sec.',
    withinLimit: 'Within length limit',
    overLimit: 'Over length limit',
    underMinimum: 'Below desktop minimum',
    invalidLength: 'Select a clip to compare',
    officialRules: 'Official rules',
}
